<template>
  <div
    class="license-image-card"
    :class="{outline:outline,borderTop:borderTop}"
  >
    <component
      :is="isTable?'table':'div'"
      class="list-items"
    >
      <p
        v-if="title"
        class="card-title"
      >
        {{ title }}
      </p>
      <p
        v-if="licenseName"
        class="license-name"
      >
        {{ licenseName }}
      </p>
      <slot name="license-list" />
    </component>
    <div
      v-if="licenseImg"
      class="list-img"
      :class="{small:smallImg}"
    >
      <MainImage
        :image="licenseImg"
        value="value"
        @input="$_popupActive($event)"
      />
    </div>
    <slot />
  </div>
</template> 
<script>
export default {
  name: "LicenseImageCard",
  props: {
    outline: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    licenseName: {
      type: String,
      default: "",
    },
    smallImg: {
      type: Boolean,
      default: false,
    },
    licenseImg: {
      type: String,
      default: "",
    },
    borderTop: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Boolean,
      default: false,
    },
    isTable: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    $_popupActive($event) {
      this.$emit("input", $event);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/component/license-image-card";
</style>